import './i18n';
import App from './App';
import React from 'react';
import { createRoot } from 'react-dom/client';
import store from './redux/store';
import { Provider } from 'react-redux';
import IdleSessionLogout from './IdleSessionLogout';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <IdleSessionLogout>
            <App />
        </IdleSessionLogout>
    </Provider>
);
